// src/hooks/usePreferencesModal.ts
import useUiStore from "../store/useUiStore.ts";
import Preferences from "../components/Preferences/Preferences.tsx";
import {preferencesItems} from "../models/constants/preferencesItems.tsx";

export const usePreferencesModal = () => {
  const {openModal} = useUiStore();

  return (activeItemIdx?: number) => {
    openModal(
      <Preferences items={preferencesItems} activeItemIdx={activeItemIdx}/>,
      {
        className: "md:!p-0",
        classWrap: "max-w-[48rem] md:min-h-screen-ios md:rounded-none",
        classButtonClose: "hidden md:block md:absolute md:top-5 md:right-5 dark:fill-n-400",
        classOverlay: "md:bg-n-100",
      }
    );
  };
};